import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Why geeks think girls don't like them",
  "description": "",
  "published": "2012-03-06T00:00:00.000Z",
  "redirect_from": ["/blog/why-geeks-think-girls-dont-like-them/swizec/3834"],
  "categories": "Arts, Books, England, GeekDad, Literature, Reading, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`The oldest joke online is that geeks have never seen a girl.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/bFby6rsfkX34IGZEQa9Xb5xDFnKp00DGWdhLzDw4gmw5.jpg",
        "alt": "Book at bikofe",
        "title": "Book at bikofe"
      }}></img></p>
    <p>{`Or that nice guys can't get a girl.`}</p>
    <p>{`Variations of this story have been happening all my life, my fellow geeks tell similar stories and the internet is awash with rage comics saying the same thing. But this particular story happened last night, to me.`}</p>
    <p>{`On my way home from class I went to a nearby coffee shop to read a book - it's a trick I use to get myself off the internets and reading proper books that are awesome.`}</p>
    <p>{`Upon getting there, my regular spot, the only place with a good reading light, was occupied. Some girl was there, `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Reading_%28process%29",
        "title": "Reading (process)"
      }}>{`reading a book`}</a>{`, minding her own business.`}</p>
    <p>{`I plomped my arse down at a nearby table and tried to read. There wasn't enough light.`}</p>
    <p>{`After a few moments of thought I got up and asked the girl, if I could sit at her table because the light was better. She looked up from her book, smiled, said she doesn't speak a word of `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Slovene_language",
        "title": "Slovene language"
      }}>{`Slovene`}</a>{`, but that I should totally sit next to her since she's hogging the only good light.`}</p>
    <p>{`Sat down, thinking `}<em parentName="p">{`"My, that girl was kinda cute. Foreign too, I bet she'd be super interesting to talk to! Wonder what she's doing here ..."`}</em>{` And I started reading.`}</p>
    <p>{`After about half an hour, the girl stopped reading and just sort of sat there, looking kind of lost for a couple of minutes. I could almost `}<em parentName="p">{`feel`}</em>{` her eyes peering through me ... but the book was really interesting. I kept reading.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/03/G2XU3IIWNOBNXBYGGLNXKAEFFSZFOVK4HEPG0WFYTMA2FHCB2.jpg",
        "alt": "Bikofe",
        "title": "Bikofe"
      }}></img></p>
    <p>{`She stood up and wandered about the coffee shop, looking at different things on the wall and just generally looking like a person loitering around waiting for someone to afford an opportunity to be spoken to.`}</p>
    <p>{`I was the only other person there.`}</p>
    <p>{`Finally she decided to leave. But before she did she came up to me, gave me a super warm smile and a cute good bye. All I did was a `}<em parentName="p">{`Huh? Oh right, bye.`}</em></p>
    <p>{`Opportunity squandered.`}</p>
    <p>{`Here was a cute girl that would doubtlessly be really interesting to talk to, who actually `}<em parentName="p">{`wanted`}</em>{` to talk to me. But I just didn't give her a chance because I was there to read a book, damn it.`}</p>
    <p>{`I think this is something us geeks do `}<strong parentName="p">{`a lot`}</strong>{`. We pride ourselves on our laser-focused minds, being able to `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/why-programmers-work-at-night/swizec/3198",
        "title": "Why programmers work at night"
      }}>{`construct glass castles in our heads`}</a>{` when tackling big problems, but we often shut ourselves out of random opportunities - what people call `}<em parentName="p">{`serendipity`}</em>{`.`}</p>
    <p>{`There was a line in my old startup pitch: `}<em parentName="p">{`"`}<a parentName="em" {...{
          "href": "http://www.imdb.com/title/tt0240890/",
          "title": "Serendipity (film)"
        }}>{`Serendipity`}</a>{` is looking for a needle in a haystack and finding the farmer's daughter."`}</em></p>
    <p>{`Except for engineers the line would be: `}<em parentName="p">{`"Serendipity is looking for a needle in a haystack and finding the farmer's daughter, then being pissed off that you couldn't find the needle and going home without even saying Hello to the daughter."`}</em></p>
    <p>{`And that's why the internet's oldest joke is that geeks have never seen a girl.`}</p>
    <p>{`PS: this likely also has a lot to do with how different business-type founders are from engineer-type founders, that openness to random opportunities that pop up everywhere. Definitely something engineers should work on :)`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/03/787189897.jpg",
          "alt": null
        }}></img><a parentName="li" {...{
          "href": "http://berinkinsman.wordpress.com/2012/03/05/geekout-on-jason-and-the-argonauts/"
        }}>{`GeekOut on Jason and the Argonauts`}</a>{`(berinkinsman.wordpress.com)`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/03/786798097.jpg",
          "alt": null
        }}></img><a parentName="li" {...{
          "href": "http://www.wired.com/geekdad/2012/03/books-to-read-to-kids/"
        }}>{`Books Geeks Should Read to Their Kids: Your Additions to Our List`}</a>{`(wired.com)`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/03/787447587.jpg",
          "alt": null
        }}></img><a parentName="li" {...{
          "href": "http://r.zemanta.com/?u=http%3A//geekout.blogs.cnn.com/2012/03/05/the-worlds-first-steampunk-bedtime-story/&a=78744758&rid=867f674b-7187-44ee-8f19-618550443921&e=ee6f5798c6cc490b9a4a4724e57d38bb"
        }}>{`First steampunk bedtime story`}</a>{`(geekout.blogs.cnn.com)`}</li>
    </ul>
    <hr></hr>
    <ul>
      <li parentName="ul"><img parentName="li" {...{
          "src": "https://swizec.com/blog/wp-content/uploads/2012/03/675183767.jpg",
          "alt": null
        }}></img><a parentName="li" {...{
          "href": "http://nerdgasmnoire.wordpress.com/2011/12/10/blessed-are-the-geek-for-they-shall-inherit-the-earth/"
        }}>{`"Blessed are the geek, for they shall inherit the earth."`}</a>{`(nerdgasmnoire.wordpress.com)`}</li>
    </ul>
    <hr></hr>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=867f674b-7187-44ee-8f19-618550443921",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      